import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const wix = (id, w, h) => `https://static.wixstatic.com/media/${id}/v1/fill/w_${w},h_${h},al_c,q_85/img.jpg`;

const cards = [
  {
    n: "01",
    title: "Video Production",
    tag: "From multi-camera shows to promos — one of Essex's most adaptable video teams.",
    to: "/services/video-production",
    img: wix("1fe187_83eada885be74b48b91e5f609c40f245~mv2.jpg", 800, 1000),
  },
  {
    n: "02",
    title: "Live Streams",
    tag: "Multi-camera live & hybrid broadcasts — Teams, Zoom, YouTube & webinar.",
    to: "/live",
    img: wix("1fe187_4962044db2524690a33ce2e778b22a84~mv2.jpg", 800, 1000),
  },
  {
    n: "03",
    title: "The Studios",
    tag: "Photo, video & podcast studios in Wickford — hire from £45.",
    to: "/studios",
    img: wix("1fe187_94683d4f534141088e6cc5090fdc43f2~mv2.png", 800, 1000),
  },
];

export const Services = () => (
  <section id="services" className="py-24 sm:py-32" data-testid="services-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-16"
      >
        <p className="text-sm uppercase tracking-[0.3em] font-semibold text-[#E80042] mb-4">02 — What We Do</p>
        <h2 className="font-grotesk font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none max-w-3xl">
          Cameras, streams & <span className="text-[#E80042]">studios.</span>
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-6">
        {cards.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className={`h-[440px] sm:h-[500px] ${i === 1 ? "md:mt-12" : ""}`}
          >
            <Link
              to={s.to}
              data-testid={`service-card-${s.n}`}
              className="group relative overflow-hidden rounded-lg bg-[#0A0A0A] block w-full h-full hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300"
            >
              <img loading="lazy"
                src={s.img}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover opacity-70 grayscale group-hover:grayscale-0 group-hover:opacity-90 group-hover:scale-105 transition-[filter,opacity,transform] duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <span className="absolute top-5 left-5 font-display text-white/60 text-xl">{s.n}</span>
              <span className="absolute top-5 right-5 w-9 h-9 rounded-full bg-[#E80042] text-white flex items-center justify-center opacity-0 group-hover:opacity-100 -rotate-45 group-hover:rotate-0 transition-[opacity,transform] duration-300">→</span>
              <div className="absolute bottom-0 p-5">
                <h3 className="font-display uppercase text-white text-2xl sm:text-3xl tracking-tight">{s.title}</h3>
                <p className="text-white/80 text-sm mt-2 leading-relaxed max-w-sm opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-24 transition-[opacity,max-height] duration-400">{s.tag}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>

      <div className="mt-12 text-left">
        <Link to="/services" data-testid="services-view-all-link" className="link-underline font-grotesk font-bold text-lg">
          View all services →
        </Link>
      </div>
    </div>
  </section>
);
